<template>
  <div class="page">
    <div class="page__bd">
      <div class="weui-gallery">
        <img
          crossorigin="anonymous"
          :src="imgUrl"
          id="weui-gallery__img"
          class="weui-gallery__img"
        />
        <div class="weui-gallery__tip">
          <p>可邀请同事加入云系统，长按图片分享</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import session from "@/util/session.js";
import { getBaseUrl } from '@/util/env';

export default {
  data() {
    return {
      imgUrl: null,
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.loadCard();
    });
  },
  methods: {
    loadCard() {
      var me = this,
        account = session.get().account,
        company = account.defaultCompany
      me.imgUrl = getBaseUrl() + `/api/commons/share/qrcode?userName=${account.realname}&companyId=${company.id}&companyName=${company.name}`
    }
  }
}
</script>

<style scoped>
.weui-gallery {
  background-color: inherit;
  display: block;
  top: 20px;
  bottom: 20px;
  left: 20px;
  right: 20px;
}

.weui-gallery__tip {
  position: absolute;
  bottom: calc(60px + env(safe-area-inset-bottom));
  width: 100%;
  color: var(--weui-FG-1);
  text-align: center;
}
</style>